export default __webpack_public_path__ + "static/media/sad.2ef5bcd2.png";